import { safeFetch } from "./functionFromExport";

// Определяем функцию вне IIFE, чтобы её можно было экспортировать
const logToServer = (level, args) => {
    const message = args.map(arg => {
        if (arg instanceof Error) {
            return `Ошибка (${arg.name}): ${arg.message}\n${arg.stack}`;
        }
        // Проверяем, является ли аргумент объектом
        if (typeof arg === 'object' && arg !== null) {
            try {
                return JSON.stringify(arg);
            } catch (e) {
                return '[Не удалось сериализовать]';
            }
        }
        return arg;
    }).join(' ');

    safeFetch('/log', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            level,
            location: document.location.pathname,
            message,
            timestamp: new Date().toISOString()
        }),
    })
        .then(response => response.text())
        .then((data) => {
            console.log('Лог Записан', data);
        })
        .catch(error => {
            console.error('Ошибка при отправке сообщения на сервер:', error);
        });
};

export { logToServer };

(function () {
    const originalMethods = ['info', 'warn', 'error', 'debug'];

    originalMethods.forEach(method => {
        const originalMethod = console[method].bind(console);

        console[method] = function (...args) {
            originalMethod.apply(console, args);
            logToServer(method, args);
        };
    });
})();
